import { TableCell, TableRow, Typography, makeStyles } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";
import Skeleton from "@material-ui/lab/Skeleton";
import React from "react";
import { BeaconItemDataQualityReport, FieldDataQuality, FieldDataQualitySummary } from "../../../api/graphQL/queryModels";
import DataQualityScoreIcon from "./DataQualityScoreIcon";
import { Author } from "../people";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    root: {
        "& > *": {
            borderBottom: "unset"
        }
    },
    avatar: {
        background: "#fff",
        "& > img": {
            width: 40,
            height: "auto"
        }
    },
    centered: {
        justifyItems: "center",
        alignItems: "center"
    },
    left: {
        justifyItems: "left",
        alignItems: "left"
    },
    right: {
        textAlign: "right",
        verticalAlign: "middle"
    },
    aligned: {
        display: "inline-flex",
        "& > *": {
            marginRight: theme.spacing(1)
        }
    },
    expansionCell: {
        paddingBottom: 0,
        paddingTop: 0
    },
    wrapper: {
        display: "flex",
        height: "100%",
        flexDirection: "column",
        alignContent: "center",
        justifyContent: "center",
        "& > a": {
            textDecoration: "none",
            color: "inherit"
        }
    }
}));

const ItemDataQualityTableRow: React.FunctionComponent<{
    report?: BeaconItemDataQualityReport;
}> = (props) => {
    const classes = useStyles();
    const item = props.report?.beaconItem;

    const getFieldByName = (name: string): FieldDataQualitySummary | undefined => {
        return (props.report?.fields || []).find((f: FieldDataQuality) => f.fieldName.toLowerCase() === name.toLowerCase());
    };
    const fieldNames = ["name", "previewDescription", "description", "Category", "Tags", "resumeGroup"];

    return (
        <TableRow className={classes.root}>
            <TableCell>
                <span className={clsx(classes.wrapper, classes.left)}>
                    <Typography component={RouterLink} to={`/items/${item?.id}`}>
                        {item ? item.name : <Skeleton variant="text" width={140} />}
                    </Typography>
                </span>
            </TableCell>
            <TableCell />
            <TableCell>
                {item ? item.author ? <Author author={item.author} createDate={null} /> : null : <Skeleton variant="text" width={100} />}
            </TableCell>
            <TableCell>
                <span className={clsx(classes.wrapper, classes.left)}>
                    <Typography>{props.report ? props.report?.overallScore : <Skeleton variant="text" width={20} />}</Typography>
                </span>
            </TableCell>
            {fieldNames.map((fieldName) => {
                const fieldQualityScore = getFieldByName(fieldName);
                return (
                    <TableCell key="TableCell 1">
                        <span className={clsx(classes.wrapper, classes.centered)}>
                            <DataQualityScoreIcon score={fieldQualityScore?.score} violations={fieldQualityScore?.violations} />
                        </span>
                    </TableCell>
                );
            })}
        </TableRow>
    );
};

export default ItemDataQualityTableRow;
